<div class="hero-banner bg-white">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="hero-banner-content black-color">
                            <span class="sub-title">"Your story"</span>
                            <h1>Story Media Digital</h1>
                            <p>Dijital dünyada markalara ses vermek için kuruldu. Hikâye anlatımının gücüne inanıyor ve
                                markaların dijitalde büyümesine yardımcı oluyoruz.</p>
                            <!-- <div class="btn-box">
                                <a routerLink="/courses-2-columns-style-1" class="default-btn"><i
                                        class='bx bx-move-horizontal icon-arrow before'></i><span class="label">View
                                        Courses</span><i class="bx bx-move-horizontal icon-arrow after"></i></a>
                                <a routerLink="/contact" class="optional-btn">Get Started Free</a>
                            </div> -->
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="hero-banner-image text-center">
                            <img style="width:80%; border-radius:50%;" src="assets/story/logo/bg-black.png" alt="image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>